import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import CbsDataDownloadSection from '../components/admin/CbsDataDownloadSection'
import MongoRestoreSection from '../components/admin/MongoRestoreSection'

const Settings: FC = () => {
  const translate = useTranslate()

  return (
    <Box sx={{ maxWidth: 720, mt: 2, ml: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {translate('settings.title')}
      </Typography>

      <CbsDataDownloadSection />
      <MongoRestoreSection />
    </Box>
  )
}

export default Settings
